import { configureStore } from "@reduxjs/toolkit";
import auth from "features/auth/slice";
import account from "features/account/slice";
import category from "features/category/slice";
import shipper from "features/shipper/slice";
import restaurant from "features/restaurant/slice";
import voucher from "features/voucher/slice";
import campaign from "features/campaign/slice";
import collection from "features/collection/slice";
import ad from "features/ad/list/slice";
import adType from "features/ad/type/slice";
import bannerUser from "features/banner/app-user/slice";
import bannerMerchant from "features/banner/app-merchant/slice";
import notification from "features/notification/slice";
import message from "features/message/slice";
import user from "features/user/slice";
import order from "features/order/history/slice";
import newOrder from "features/order/new/slice";
import restaurantReview from "features/review/restaurant/slice";
import shipperReview from "features/review/shipper/slice";
import contact from "features/contact/slice";
import config from "features/setup/slice";
import walletRequest from "features/wallet-request/slice";
import mapService from "features/super-setup/map-service/slice";
import region from "features/region/slice";
import superAccount from "features/super-account/slice";
import restaurantLabel from "features/restaurant-label/slice";
import restaurantIdentity from "features/restaurant-identity/slice";
import restaurantContract from "features/restaurant-contract/slice";
import superWalletRequest from "features/super-wallet-request/slice";
import walletTransaction from "features/wallet/slice";
import flashSale from "features/flashsale/slice";
import bikePlace from "features/bike-place/slice";
import bikeVoucher from "features/bike-voucher/slice";
import bikeCombo from "features/bike-combo/slice";
import bikeComboTransaction from "features/bike-combo-transaction/slice";
import bikeConfig from "features/bike-setup/slice";
import bikeOrder from "features/bike-order/history/slice";
import bikeNewOrder from "features/bike-order/new-live/slice";

import driverVoucher from "features/driver-voucher/slice";
import driverConfig from "features/driver-setup/slice";
import driverOrder from "features/driver-order/history/slice";
import driverNewOrder from "features/driver-order/new-live/slice";

import expressVoucher from "features/express-voucher/slice";
import expressCombo from "features/express-combo/slice";
import expressComboTransaction from "features/express-combo-transaction/slice";
import expressConfig from "features/express-setup/slice";
import expressOrder from "features/express-order/history/slice";
import expressNewOrder from "features/express-order/new-live/slice";

import foodConfig from "features/food-setup/slice";
import superConfig from "features/super-setup/system/slice";

export const store = configureStore({
  reducer: {
    auth,
    account,
    category,
    shipper,
    restaurant,
    voucher,
    campaign,
    collection,
    ad,
    adType,
    banner: bannerUser,
    bannerMerchant,
    notification,
    restaurantReview,
    shipperReview,
    user,
    order,
    newOrder,
    message,
    contact,
    config,
    superConfig,
    walletRequest,
    mapService,
    region,
    superAccount,
    restaurantLabel,
    restaurantIdentity,
    restaurantContract,
    superWalletRequest,
    walletTransaction,
    flashSale,
    bikePlace,
    bikeVoucher,
    bikeCombo,
    bikeComboTransaction,
    bikeConfig,
    bikeOrder,
    bikeNewOrder,

    driverVoucher,
    driverConfig,
    driverOrder,
    driverNewOrder,

    expressVoucher,
    expressCombo,
    expressComboTransaction,
    expressConfig,
    expressOrder,
    expressNewOrder,

    foodConfig,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
